import { IonSpinner } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { LimpiarSelectReceta } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import {
  setListErrorReceta,
  setReceta,
} from "../../../context/Actions/turnos/recetaDigital";
import { PortalContext } from "../../../context/Provider";
import "../../../pages/RecetasDigitales/RecetasDigitales.css";
import camelize from "../../../../global/utils/camelize";
import "./PreguntaReceta.css";
import { GlobalContext } from "../../../../global/context/Provider";
import { showToaster } from "global/context/action/toaster/toaster";

const RecetaDigitalCard = () => {
  const {
    modalDispatch,
    segundoModalDispatch,
    recetasDigitalesDispatch,
    listaFamiliaresState,
    selectDropDownDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);

  const [resetReceta, setResetReceta] = useState({
    dni: authState.auth.data.paciente.nro_documento,
    nombre: camelize(authState.auth.data.paciente.nombre),
    telefono: authState.auth.data.paciente.telefono,
    seAtendio: "",
    horario: "",
    nombreMedico: "",
    farmacia: "",
    nombreFarmaceutico: "",
    numMatriculaFarmaceutico: "",
  });
  const [resetErrores, setResetErrores] = useState({
    dni: false,
    nombre: false,
    telefono: false,
    seAtendio: false,
    horario: false,
    nombreMedico: false,
    farmacia: false,
    nombreFarmaceutico: false,
    numMatriculaFarmaceutico: false,
  });

  const dissmiss = () => {
    hideSegundoModal()(segundoModalDispatch);
    setReceta(resetReceta)(recetasDigitalesDispatch);
    setListErrorReceta(resetErrores)(recetasDigitalesDispatch);
    LimpiarSelectReceta()(selectDropDownDispatch);
  };

  const dissmissPregunta = () => {
    hideModal()(modalDispatch);
    LimpiarSelectReceta()(selectDropDownDispatch);
  };

  const modalPrevQst = () => {
    if (
      configState.config.data !== null &&
      configState.config.data.opcLinkRecetaDigital !== undefined &&
      configState.config.data.opcLinkRecetaDigital !== false
    ) {
      window.open(configState.config.data.opcLinkRecetaDigital, "_blank");
    } else {
      if (
        authState.auth.data.paciente.msjRDBlk !== null &&
        authState.auth.data.paciente.msjRDBlk !== ""
      ) {
        showToaster(
          {
            texto: authState.auth.data.paciente.msjRDBlk,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        if (
          Array.isArray(listaFamiliaresState.listaFamiliares.data) &&
          listaFamiliaresState.listaFamiliares.data.length > 0
        ) {
          modalPreguntaRecetaDigital();
        } else {
          modalRecetaDigital();
        }
      }
    }
  };

  const modalPreguntaRecetaDigital = () => {
    showModal(
      "Turnos/RecetaDigital/PreguntaReceta",
      {
        titulo: "Receta Digital",
        dissmiss: dissmissPregunta,
      },
      [
        {
          text: "Siguiente",
          clase: "ptur-preguntaReceta-btnSiguiente rb16m bgc-latex10 c-white",
          accion: modalRecetaDigital,
        },
      ],
      "centro",
      {},
      true
    )(modalDispatch);
  };

  const modalRecetaDigital = () => {
    hideModal()(modalDispatch);
    showSegundoModal(
      "Turnos/RecetaDigital/FormularioReceta",
      {
        titulo: "Receta Digital",
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(segundoModalDispatch);
  };

  return (
    <React.Fragment>
      <div className="ptur-recetasDigitales-recetaContainer">
        <div className="ptur-recetasDigitales-titulo">
          <p className="rb14b">¿Cómo solicitar orden médica?</p>
        </div>
        <div className="ptur-recetasDigitales-texto1">
          <p>
            Desarrollamos un sistema de órdenes médicas digitales, para que
            puedas continuar con tu tratamiento de forma segura y sin salir de
            tu casa.
          </p>
        </div>
        <div className="ptur-recetasDigitales-texto2">
          <ul className="ptur-recetasDigitales-items">
            <li>Hacé click en el botón "Nueva receta digital".</li>
            <li>Completá el formulario</li>
          </ul>
        </div>
        <div className="ptur-recetasDigitales-texto3">
          {configState.config.data !== null &&
          configState.config.data.portal === "dim" ? (
            <p>
              Luego, te llamaremos para coordinar una teleconsulta con un
              profesional, quien evaluará tu tratamiento. Posteriormente, te
              enviaremos la orden médica por WhatsApp o por mail en el
              transcurso de 24 a 72hs hábiles.
            </p>
          ) : (
            <p>
              Luego de completar el formulario, comuníquese a las 24 hs a
              nuestro WhatsApp de recetas (solo mensajes) para consultar el
              estado de la misma.
            </p>
          )}
        </div>
        <div className="ptur-recetasDigitales-botonContainer">
          <button
            className={
              listaFamiliaresState.listaFamiliares.loading
                ? "rb18m c-white bgc-grey65 ptur-recetasDigitales-boton"
                : "rb18m c-white bgc-primary ptur-recetasDigitales-boton"
            }
            disabled={
              listaFamiliaresState.listaFamiliares.loading ? true : false
            }
            onClick={modalPrevQst}
          >
            {listaFamiliaresState.listaFamiliares.loading ? (
              <>
                <div className="ptur-recetasDigitales-nuevaRecetaBtn">
                  <IonSpinner name="lines-small" /> Nueva receta digital
                </div>
              </>
            ) : (
              "Nueva receta digital"
            )}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecetaDigitalCard;
